const Nothing = () => null;

export default Nothing;
